import React from 'react';
import styled from 'styled-components/macro';
import { Menu } from './menu';
import { useProgress, useUser } from 'hooks/hooks';
import Progress from 'components/progress';

const Container = styled.div`
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #333;
  color: #fff;
  height: 150px;
  background-image: url(header.jpg);
  background-size: cover;

  a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
  }

  a:hover {
    color: #fff;
  }
`;

const Inner = styled.div`
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

const Flex = styled.div`
  position: absolute;
  top: 82px;
  right: 0;
  display: flex;
`;

export function Header() {
  return (
    <Container>
      <Inner>
        <Profile />

        <Flex>
          <Menu />
        </Flex>

        {/* <div onClick={() => setIsDropdownVisible((v) => !v)}>{children}</div>
      <ProfileDropdown visible={isDropdownVisible} userId={userId} /> */}
      </Inner>
    </Container>
  );
}

const Name = styled.div`
  margin-bottom: 12px;
  font-size: 36px;
  font-weight: 600;
`;

function Profile() {
  const user = useUser();
  const { collected, total } = useProgress();

  return (
    <div>
      <Name>{user?.displayName.split(' ')[0]}</Name>

      <Progress current={collected} total={total} />
    </div>
  );
}
